// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const TagOtherIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m21.46 9.45-.49-.5c-1.28-1.3-2.7-2.72-3.26-3.19q-1.48-1.23-3.46-1.25H5.2c-2.06 0-3.68 1.62-3.7 3.67v7.65c.02 2.05 1.64 3.66 3.7 3.66h8.97q2.34 0 4-1.65l.15-.15c2.47-2.46 3.4-3.4 3.53-3.6 1-1.42.83-3.41-.4-4.64"
    />
  </SvgIcon>
);

export default TagOtherIcon;
